import { IMAGESMAP } from "../../utils/imagesMap"

export const menTestimonials = {
  tanner: {
    name: "Tanner",
    icon: IMAGESMAP.RESULTS_MEN.TANNER_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.TANNER_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.TANNER_AFTER,
    quote:
      "“I have thinning hair and wanted to address the root cause, so I went with Nutrafol. The results have been great.”",
    tags: ["Visibly Thicker", "Visibly Fuller", "Hair Growth"],
    after: "3",
  },
  jose: {
    name: "Jose",
    icon: IMAGESMAP.RESULTS_MEN.JOSE_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.JOSE_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.JOSE_AFTER,
    quote: "“My hair is thicker and fuller. I also realized I sleep better.”",
    tags: ["Visibly Fuller", "Stronger Feeling", "Visibly Less Shedding"],
    after: "6",
  },
  adrian: {
    name: "Adrian",
    icon: IMAGESMAP.RESULTS_MEN.ADRIAN_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.ADRIAN_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.ADRIAN_AFTER,
    quote: "",
    tags: ["Scalp Coverage", "Hair Growth", "Visibly Thicker"],
    after: "3",
  },
  mark: {
    name: "Mark",
    icon: IMAGESMAP.RESULTS_MEN.MARK_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.MARK_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.MARK_AFTER,
    quote:
      "“I was concerned as I was thinning on top. I tried the supplement and saw remarkable improvement. I gained more confidence in myself.”",
    tags: ["Hair Growth", "Stronger Feeling", "Visibly Thicker"],
    after: "3",
  },
  brian: {
    name: "Brian",
    icon: IMAGESMAP.RESULTS_MEN.BRIAN_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.BRIAN_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.BRIAN_AFTER,
    quote:
      "“I’m definitely noticing more hair in the front, where I was thinning, as well as on the top of my head.”",
    tags: ["Visibly Fuller", "Scalp Coverage", "Hair Growth"],
    after: "3",
  },
  jason: {
    name: "Jason",
    icon: IMAGESMAP.RESULTS_MEN.JASON_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.JASON_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.JASON_AFTER,
    quote:
      "“Being younger, I wanted to see if there was something out there to help my scalp thinning. My hair has become fuller and thicker because of all of the great ingredients Nutrafol has.”",
    tags: ["Visibly Thicker", "Visibly Fuller", "Fast Growing"],
    after: "3",
  },
  sam: {
    name: "Sam",
    icon: IMAGESMAP.RESULTS_MEN.SAM_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.SAM_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.SAM_AFTER,
    quote:
      "“I noticed my hair looked a lot shinier, a lot fuller, and I felt more energetic.”",
    tags: ["Visibly Fuller", "Stronger Feeling", "Visibly Less Shedding"],
    after: "3",
  },
  anuradha: {
    name: "Anuradha",
    icon: IMAGESMAP.RESULTS_MEN.ANURADHA_TN,
    beforeImageDesktop: IMAGESMAP.RESULTS_MEN.ANURADHA_BEFORE,
    afterImageDesktop: IMAGESMAP.RESULTS_MEN.ANURADHA_AFTER,
    quote:
      "“My hair was starting to shed and that was affecting my confidence. I’m happy I found something that helps me keep my hair looking thicker and fuller.”",
    tags: ["Visibly Fuller", "Visibly Thicker", "Visibly Less Shedding"],
    after: "3",
  },
}
